import metaDataService from "src/services/metaDataService";

export const GET_METADATAS_REQUEST = "@metadata/get-metadatas-request";
export const GET_METADATAS_SUCCESS = "@metadata/get-metadatas-success";
export const GET_METADATAS_FAILURE = "@metadata/get-metadatas-failure";

export const GET_METADATA_REQUEST = "@metadata/get-metadata-request";
export const GET_METADATA_SUCCESS = "@metadata/get-metadata-success";
export const GET_METADATA_FAILURE = "@metadata/get-metadata-failure";

export const ADD_METADATA_REQUEST = "@metadata/add-metadata-request";
export const ADD_METADATA_SUCCESS = "@metadata/add-metadata-success";
export const ADD_METADATA_FAILURE = "@metadata/add-metadata-failure";

export const UPDATE_METADATA_REQUEST = "@metadata/udpate-metadata-request";
export const UPDATE_METADATA_SUCCESS = "@metadata/udpate-metadata-success";
export const UPDATE_METADATA_FAILURE = "@metadata/udpate-metadata-failure";

export const DELETE_METADATA_REQUEST = "@metadata/delete-metadata-request";
export const DELETE_METADATA_SUCCESS = "@metadata/delete-metadata-success";
export const DELETE_METADATA_FAILURE = "@metadata/delete-metadata-failure";

export function getListMetaDatas(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_METADATAS_REQUEST});
      const response = await metaDataService.getListMetaData(data);
      dispatch({
        type: GET_METADATAS_SUCCESS,
        payload: {
          response: response.data.data,
          total: response.data.data.length
        }
      });
    } catch (error) {
      dispatch({type: GET_METADATAS_FAILURE});
      throw error;
    }
  };
}

export function updateMetadata(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_METADATA_REQUEST});
      const response = await metaDataService.updateMetadata(data);
      dispatch({
        type: UPDATE_METADATA_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_METADATA_FAILURE});
      throw error;
    }
  };
}

export function deleteMetaData(data) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_METADATA_REQUEST});
      if (typeof data === "object") {
        await metaDataService.deleteMetadata(data.id);
      } else {
        await metaDataService.deleteMetadata(data);
      }
      dispatch({
        type: DELETE_METADATA_SUCCESS,
        payload: {
          data
        }
      });
    } catch (error) {
      dispatch({type: DELETE_METADATA_FAILURE});
      throw error;
    }
  };
}
